import React, { useState, useEffect } from 'react';
import './NoInternet.css';

const NoInternet = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleRetry = () => {
    if (navigator.onLine) {
      window.location.reload();
    }
  };

  return (
    <div className="no-internet-page">
      <div className="no-internet-container">
        <div className="no-internet-content">
          <div className="no-internet-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2M5 13l2 2c2.76-2.76 7.24-2.76 10 0l2-2M3 21l18-18M9 9l6 6M15 9l-6 6"/>
              <circle cx="12" cy="12" r="1"/>
            </svg>
          </div>
          <h1 className="no-internet-title">No Internet Connection</h1>
          <p className="no-internet-description">
            It looks like you're offline. Please check your internet connection and try again.
          </p>
          <div className="no-internet-status">
            <div className={`status-indicator ${isOnline ? 'online' : 'offline'}`}>
              <span className="status-dot"></span>
              <span className="status-text">
                {isOnline ? 'Connection Restored' : 'No Connection'}
              </span>
            </div>
          </div>
          <div className="no-internet-actions">
            <button
              className="no-internet-button"
              onClick={handleRetry}
              disabled={!isOnline}
            >
              {isOnline ? 'Reload Page' : 'Retry Connection'}
            </button>
          </div>
          <div className="no-internet-tips">
            <p className="tips-title">Troubleshooting Tips:</p>
            <ul className="tips-list">
              <li>Check your Wi-Fi or mobile data connection</li>
              <li>Try restarting your router or modem</li>
              <li>Disable any VPN or proxy services</li>
              <li>Check if other websites are accessible</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoInternet;
